enum EFinanceFieldTypes {
  NetClaim="NetClaim",
  OriginalLoanAmount="OriginalLoanAmount"
}

export default EFinanceFieldTypes;
